import texts from './texts-processed.json';
import instrument_names from './instrument-name-processed.json';

const languageIds = {
    "en": 0,
    "zh_hk": 1,
    "zh_cn": 2
}

export default class TextManager {
    // static language = "en";
    static language = this.getDefaultLanguageCode();

    static getDefaultLanguageCode() {
        var language = window.userLanguage;
        if(!language){
            language = navigator.language
        }
        if (/^zh\b/.test(language)) {
            if (new RegExp(/\bCN$/, "i").test(language) || new RegExp(/\bHans$/, "i").test(language)) {
                return "zh_cn";
            } else {
                return "zh_hk";
            }
        } else {
            return "en";
        }
    }

    static getText(key) {
        return texts[key][languageIds[this.language]]
    }

    static getInstrumentNameText(key) {
        return instrument_names[key][languageIds[this.language]]
    }
}